export default {"src":"/_next/static/media/alert.fa8bcc9d.svg","height":20,"width":20};